const updateItems = [
  {
    id: 1,
    date: '2026-07-29',
    tag: '资源更新',
    title: '「咒术回战」第271话已更新，51漫画免费版下载同步上线',
    description: '宿傩与虎杖的最终决战进入白热化阶段，本话高能战斗场面不容错过。高清画质已同步至51漫画下载资源库，支持离线缓存。',
  },
  {
    id: 2,
    date: '2026-07-28',
    tag: '新番上线',
    title: '2026夏季新番「星界之梯」全12话登陆51漫画下载专区',
    description: '科幻题材新锐之作，讲述人类在星际阶梯上探索未知文明的宏大冒险。51漫画免费版下载已开放全集获取。',
  },
  {
    id: 3,
    date: '2026-07-27',
    tag: '平台公告',
    title: '51漫画APP v4.2.0版本发布，离线下载速度提升300%',
    description: '新版本采用智能预加载技术，51漫画免费版下载体验全面升级。新增夜间护眼模式与智能书签云同步功能。',
  },
  {
    id: 4,
    date: '2026-07-26',
    tag: '完结推荐',
    title: '「迷宫饭」全97话完结纪念，51漫画下载全集永久收藏',
    description: '这部融合奇幻与美食的独特作品正式完结，51漫画下载资源已整合全集高清版，推荐所有奇幻爱好者收藏。',
  },
  {
    id: 5,
    date: '2026-07-25',
    tag: '热门活动',
    title: '暑期漫画马拉松活动开启，51漫画免费版下载限时无限制',
    description: '暑假期间51漫画免费版下载不限量开放，每日额外赠送5GB高速下载流量，助您畅读整个夏日。',
  },
  {
    id: 6,
    date: '2026-07-24',
    tag: '资源更新',
    title: '「一人之下」碧游村篇完结，51漫画下载全篇一次获取',
    description: '国漫巅峰之作碧游村篇正式完结，51漫画下载已整合全篇108话高清资源，支持一键批量离线缓存。',
  },
  {
    id: 7,
    date: '2026-07-23',
    tag: '新番上线',
    title: '「刃牙道」第二季重磅登陆51漫画下载资源站',
    description: '地表最强生物之战再开，范马刃牙与原始人皮可的史诗对决。51漫画免费版下载已上线前50话高清资源。',
  },
  {
    id: 8,
    date: '2026-07-22',
    tag: '平台公告',
    title: '51漫画网CDN节点扩充至全球28个，下载速度全面提升',
    description: '为进一步优化51漫画下载体验，平台已完成全球CDN节点部署，国内外用户均可享受极速下载与流畅阅读。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            5151漫画网的最新51漫画下载资源与平台资讯
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-200"></div>

          <div className="space-y-0">
            {updateItems.map((item) => (
              <a
                key={item.id}
                href="#index"
                className="group relative flex gap-6 pb-8 last:pb-0 cursor-pointer"
              >
                <div className="relative z-10 flex-shrink-0 w-[38px] h-[38px] flex items-center justify-center rounded-full bg-background-50 border-2 border-background-200 group-hover:border-primary-300 transition-colors">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                </div>

                <div className="flex-1 min-w-0 bg-background-100 rounded-xl p-5 border border-background-200/60 group-hover:border-primary-200 transition-all">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className="px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base text-foreground-900 mb-1.5 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}